<template>
  <div class="apply-list-item" @click="$emit('view')">
    <div class="left">
      <h1>{{ data.name }}</h1>
      <h2>合作期：{{ data.start_time | date }} 至 {{ data.end_time | date }}</h2>
    </div>
    <div class="right" :class="storeStatus[data.status].class">
      <i :class="storeStatus[data.status].icon" />
      <span>{{ storeStatus[data.status].name }}</span>
    </div>
  </div>
</template>

<script>
import { storeStatus, filters } from "./utils"

export default {
  props: ["data"],
  filters,
  data() {
    return {
      storeStatus
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";

.apply-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: $border;
  border-radius: 4px;
  padding: 10px 15px;
  box-shadow: $deep-shadow;
  margin-top: 10px;
  transition: all 0.1s;
  background: white;

  &:hover {
    background: #f7f7f7;
  }

  .left {
    h1 {
      font-size: 1rem;
    }
    h2 {
      font-size: 0.8rem;
      font-weight: 400;
      line-height: 1.3;
      opacity: 0.6;
    }
  }
  .right {
    font-size: 0.8rem;
    text-align: right;
    min-width: 70px;
    i {
      margin-right: 3px;
    }
  }
}
</style>
